<template>
  <div class="popular-brands">
    <div class="app-container d-flex justify-center" style="position: relative">
      <div class="popular-brands_wrap">
        <a
          v-for="(item, i) in items"
          @mouseenter="item.currentImage = item.animImage"
          @mouseleave="item.currentImage = item.staticImage"
          :key="`pb-${i}`"
          :href="item.link"
          class="popular-brands_link"
        >
          <div class="popular-brands_image-wrap">
            <img
              :src="item.currentImage || item.staticImage"
              :alt="item.title"
            />
          </div>
          <span>{{ item.title }}</span>
        </a>
      </div>
      <button
        @click="$emit('toggle-brands-menu')"
        type="button"
        class="brands-menu_switcher"
      >
        <span>{{ mess["all_brands"] }}</span>
        <v-icon v-if="isBrandMenu" color="#ffffff" size="20">mdi-close</v-icon>
        <v-icon v-else color="#ffffff" size="20">mdi-chevron-down</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopularBrands",
  props: {
    items: {
      type: [Array, null],
      default: () => []
    },
    isBrandMenu: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
@import "PopularBrands";
</style>
